// selectors.js
export const selectDataSingleMatterData = (state) => state.singleMatterData.data;
export const selectDataSingleMatterLoading = (state) => state.singleMatterData.loading;
export const selectDataSingleMatterError = (state) => state.singleMatterData.error;

export const selectSingleMatterCourtData = (state) => state.courtData.data;
export const selectSingleMatterCourtLoading = (state) => state.courtData.loading;
export const selectSingleMatterCourtError = (state) => state.courtData.error;

export const selectDataSingleMatterBackgroundData = (state) => state.backgroundData.data;
export const selectDataSingleMatterBackgroundLoading = (state) => state.backgroundData.loading;
export const selectDataSingleMatterBackgroundError = (state) => state.backgroundData.error;

export const selectDataSingleMatterRelationshipData = (state) => state.relationshipData.data;
export const selectDataSingleMatterRelationshipLoading = (state) => state.relationshipData.loading;
export const selectDataSingleMatterRelationshipError = (state) => state.relationshipData.error;

export const selectDataSingleMatterChildrenData = (state) => state.childrenData.data;
export const selectDataSingleMatterChildrenLoading = (state) => state.childrenData.loading;
export const selectDataSingleMatterChildrenError = (state) => state.childrenData.error;

export const selectDataSingleMatterEmploymentData = (state) => state.employmentData.data;
export const selectDataSingleMatterEmploymentLoading = (state) => state.employmentData.loading;
export const selectDataSingleMatterEmploymentError = (state) => state.employmentData.error;

export const selectDataSingleMatterIncomeBenefitsData = (state) => state.incomeBenefits.data;
export const selectDataSingleMatterIncomeBenefitsLoading = (state) => state.incomeBenefits.loading;
export const selectDataSingleMatterIncomeBenefitsError = (state) => state.incomeBenefits.error;

export const selectDataSingleMatterAssetsData = (state) => state.assetsData.data;
export const selectDataSingleMatterAssetsLoading = (state) => state.assetsData.loading;
export const selectDataSingleMatterAssetsError = (state) => state.assetsData.error;

export const selectDataSingleMatterExpenseData = (state) => state.expenseData.data;
export const selectDataSingleMatterExpenseLoading = (state) => state.expenseData.loading;
export const selectDataSingleMatterExpenseError = (state) => state.expenseData.error;

export const selectDataSingleMatterDebtData = (state) => state.debtData.data;
export const selectDataSingleMatterDebtLoading = (state) => state.debtData.loading;
export const selectDataSingleMatterDebtError = (state) => state.debtData.error;

export const selectDataSingleMatterOtherPersonsData = (state) => state.getOtherPersons.data;
export const selectDataSingleMatterOtherPersonsLoading = (state) => state.getOtherPersons.loading;
export const selectDataSingleMatterOtherPersonsError = (state) => state.getOtherPersons.error;

// export const selectDataSingleMatterREPLACEData = (state) => state.REPLACE.data;
// export const selectDataSingleMatterREPLACELoading = (state) => state.REPLACE.loading;
// export const selectDataSingleMatterREPLACEError = (state) => state.REPLACE.error;